import { QuestionSet } from '@/types';

const NOW = new Date('2024-01-01T00:00:00Z');

export const LOCAL_AI_QUESTION_SET: QuestionSet = {
  id: 'local-ai-question-set',
  name: 'AI_Question_Sample',
  description: 'Sample AI question set used when Firestore access is unavailable.',
  questions: [
    {
      id: 'ai-question-stage-1',
      type: 'question',
      order: 1,
      question: {
        id: 'ai-question-1',
        text: 'Which planet is known as the Red Planet?',
        choices: ['Mars', 'Venus', 'Jupiter', 'Saturn'],
        correctAnswerIndex: 0,
        questionReadingTimeSeconds: 10,
        arenaPlayTimeSeconds: 12,
        points: 'standard',
        category: 'Science',
        difficulty: 'easy',
        explanation: 'Mars appears red due to iron oxide (rust) on its surface.',
        createdAt: NOW,
        updatedAt: NOW
      }
    },
    {
      id: 'ai-question-stage-2',
      type: 'bonus_round',
      order: 2,
      bonusRound: {
        id: 'ai-bonus-round-1',
        name: 'Power-Up Selection',
        selectionTimeSeconds: 8,
        availableItems: ['speed-boost', 'shield', 'double-points'],
        assignRandomly: false,
        isActive: true,
        createdAt: NOW,
        updatedAt: NOW
      }
    },
    {
      id: 'ai-question-stage-3',
      type: 'question',
      order: 3,
      question: {
        id: 'ai-question-2',
        text: 'In coding, what does “AI” stand for?',
        choices: ['Algorithm Integration', 'Automated Interface', 'Artificial Intelligence', 'Adaptive Input'],
        correctAnswerIndex: 2,
        questionReadingTimeSeconds: 10,
        arenaPlayTimeSeconds: 12,
        points: 'standard',
        category: 'Technology',
        difficulty: 'easy',
        explanation: 'AI is short for Artificial Intelligence.',
        createdAt: NOW,
        updatedAt: NOW
      }
    },
    {
      id: 'ai-question-stage-4',
      type: 'question',
      order: 4,
      question: {
        id: 'ai-question-3',
        text: 'Which of the following animals can fly?',
        choices: ['Cheetah', 'Penguin', 'Bat', 'Kangaroo'],
        correctAnswerIndex: 2,
        questionReadingTimeSeconds: 10,
        arenaPlayTimeSeconds: 12,
        points: 'standard',
        category: 'Biology',
        difficulty: 'medium',
        explanation: 'Bats are mammals capable of sustained flight.',
        createdAt: NOW,
        updatedAt: NOW
      }
    }
  ],
  createdBy: 'ai-system',
  createdAt: NOW,
  updatedAt: NOW,
  isActive: true,
  totalQuestions: 3,
  estimatedDuration: 6,
  difficulty: 'mixed',
  tags: ['ai', 'sample'],
  status: 'published'
};
